module.exports = __webpack_public_path__ + "static/media/kelp.c7468abd.jpg";